import React from 'react'
import MenuItem from './MenuItem'
import MenuItemSeparator from './MenuItemSeparator'
import MenuSection from './MenuSection'

const MenuList = (props) => {
  const { currentUrl, menuConfig, layoutConfig, currentUser } = props

  return menuConfig.aside.items.map((child, index) =>
    currentUser ? (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={`menuList${index}`}>
        {child.section && <MenuSection item={child} />}
        {child.separator && <MenuItemSeparator item={child} />}
        {child.title && (
          <MenuItem // prettier-ignore
            item={child}
            currentUrl={currentUrl}
            layoutConfig={layoutConfig}
            currentUser={currentUser}
          />
        )}
      </React.Fragment>
    ) : null,
  )
}

export default MenuList
